import { createSvgIcon } from "@mui/material";

export const TestDaysIcon = createSvgIcon(
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="M22.6667 27.3333C22.6667 27.7018 22.3685 28 22 28H6C5.63151 28 5.33333 27.7018 5.33333 27.3333C5.33333 26.9648 5.63151 26.6667 6 26.6667H22C22.3685 26.6667 22.6667 26.9648 22.6667 27.3333V27.3333ZM16 25.3333C16.3685 25.3333 16.6667 25.0352 16.6667 24.6667C16.6667 24.2982 16.3685 24 16 24H12C11.6315 24 11.3333 24.2982 11.3333 24.6667C11.3333 25.0352 11.6315 25.3333 12 25.3333H16V25.3333ZM28 2.66667V20C28 21.4727 26.806 22.6667 25.3333 22.6667H2.66667C1.19401 22.6667 0 21.4727 0 20V2.66667C0 1.19401 1.19401 0 2.66667 0H25.3333C26.806 0 28 1.19401 28 2.66667ZM22.6667 11.3333C22.6667 10.9648 22.3685 10.6667 22 10.6667H16.8932C16.638 10.6667 16.4056 10.8112 16.293 11.0397L14.9596 13.7064L13.1999 6.83984C13.0964 6.48633 12.7259 6.28451 12.3724 6.38802C12.2188 6.43294 12.0866 6.5319 12 6.66667L9.33333 10.6667H6C5.63151 10.6667 5.33333 10.9648 5.33333 11.3333C5.33333 11.7018 5.63151 12 6 12H9.66667C9.88997 12 10.0996 11.8906 10.2266 11.7064L12.2799 8.6263L14.0801 15.8262C14.1491 16.097 14.3763 16.2975 14.6536 16.3327C14.9076 16.3301 15.1393 16.1862 15.2539 15.9596L17.334 11.9993H22.0007C22.3691 11.9993 22.6673 11.7012 22.6673 11.3327L22.6667 11.3333Z"
        fill="#2962FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_8465_32515">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  "Test Days Icon"
);
